<ion-content class="ion-no-padding">
  <div class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">
          You have tasks due soon or with reminders
        </ion-title>
        <ion-buttons slot="end" class="ion-no-margin">          
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>

      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Task Details</ion-title>
      </div>

      <div class="form-container">
        <ng-container *ngIf="tasks && tasks.length; else noTasks">
          <ion-list>
            <ion-item *ngFor="let task of tasks">
              <ion-label>
                <h3>Subject: {{ task.subject }}</h3>
                <p>Task ID: <span (click)="closeModal()" routerLink="/tasks/details/{{task.taskId}}" class="clickable-text">{{ task.taskId }}</span></p>
                <p *ngIf="task.leadId">Lead ID: <span (click)="closeModal()" routerLink="/leads/details/{{task.leadId}}" class="clickable-text">{{ task.leadId }}</span></p>
                <p>Due Date: {{ task.dueDate | date:'MMM d, yyyy - h:mm a' }}</p>
                <ng-container *ngIf="task.remember">
                  <p>Reminder Date: {{ task.rememberDate | date:'MMM d, yyyy - h:mm a' }}</p>
                </ng-container>
              </ion-label>
            </ion-item>
          </ion-list>
        </ng-container>
        <ng-template #noTasks>
          <p>No tasks due soon or with reminders.</p>
        </ng-template>
      </div>
    </div>
  </div>
</ion-content>
